import baseAPI from "@/http";

const router = "api/seloClienteOcultoEvidencias";

export const seloClienteOcultoEvidenciasAPI = {
  add: (arquivos) =>
    baseAPI.post(`${router}/adicionar-selo-diagnostico-evidencia`, arquivos),
  atualizar: (resposta) =>
    baseAPI.put(`${router}/atualizar-diagnostico-resposta`, resposta),
  delete: (evidenciaId) => baseAPI.delete(`${router}/${evidenciaId}`),
  download: (evidenciaId) =>
    baseAPI.get(`${router}/download-diagnostico-evidencia/${evidenciaId}`, {
      responseType: "blob",
    }),
  get: (evidenciaId) => baseAPI.get(`${router}/${evidenciaId}`),
};
